export default __webpack_public_path__ + "static/media/grade_icons_easy.c1899e50.png";